import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';

import './helpers/highlightjs';

import { AuthInterceptorService } from './services/auth-interceptor.service';

import { AppComponent } from './components/app/app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './components/home/home.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PageComponent } from './components/page/page.component';
import { UserComponent } from './components/user/user.component';
import { LoaderComponent } from './components/loader/loader.component';
import { DocumentComponent } from './components/document/document.component';
import { DocumentRequestComponent } from './components/document-request/document-request.component';
import { DocumentHeadingComponent } from './components/document-heading/document-heading.component';
import { DocumentAnchorComponent } from './components/document-anchor/document-anchor.component';
import { DocumentTextComponent } from './components/document-text/document-text.component';
import { DocumentCodeComponent } from './components/document-code/document-code.component';
import { CredentialsModalComponent } from './components/credentials-modal/credentials-modal.component';
import { SldsModalComponent } from './components/slds-modal/slds-modal.component';
import { SldsIconDirective } from './directives/slds-icon.directive';
import { DocumentLockComponent } from './components/document-lock/document-lock.component';
import { PlatformInterceptorService } from './services/platform-interceptor.service';
import { ReleaseNotesComponent } from './components/release-notes/release-notes.component';
import { VersionComponent } from './components/version/version.component';
import { HeaderComponent } from './components/header/header.component';
import { HeadlinesComponent } from './components/headlines/headlines.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';

@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        HomeComponent,
        NavigationComponent,
        PageComponent,
        UserComponent,
        LoaderComponent,
        DocumentComponent,
        DocumentRequestComponent,
        DocumentHeadingComponent,
        DocumentAnchorComponent,
        DocumentTextComponent,
        DocumentCodeComponent,
        CredentialsModalComponent,
        SldsModalComponent,
        SldsIconDirective,
        DocumentLockComponent,
        ReleaseNotesComponent,
        VersionComponent,
        HeaderComponent,
        HeadlinesComponent,
        BreadcrumbsComponent,
        NotFoundComponent,
        SearchResultsComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule, // according to docs, you should import HttpClientModule after BrowserModule
        AppRoutingModule,
        FormsModule,
        ClickOutsideModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PlatformInterceptorService,
            multi: true,
        }
    ]
})
export class AppModule { }
